import { Analytics, UserProps, Event } from "./types.ts";

export class LoggerAnalytics implements Analytics {
  async track(event: Event, user?: UserProps): Promise<void> {
    try {
      globalThis.console.log(event, user);
    } catch (error) {
      global?.console?.error(error);
    }
  }

  async updateUser(userProps: UserProps): Promise<void> {
    try {
      globalThis.console.log(userProps);
    } catch (error) {
      global?.console?.error(error);
    }
  }

  async getVariant(experimentKey: string): Promise<string | null> {
    try {
      globalThis.console.log(experimentKey);
    } catch (error) {
      global?.console?.error(error);
    }
    return null;
  }
}
